module.exports = __webpack_public_path__ + "static/img/IMG_20240209_142756.ee9a80cb.jpg";